// extracted by mini-css-extract-plugin
export default {"dataCell":"DataCell_dataCell__JdVWD","dataCell_highlighted":"DataCell_dataCell_highlighted__n5JwT","dataCell_bolded":"DataCell_dataCell_bolded__STYGx"};